export default __webpack_public_path__ + "static/media/busaryPayments.d5ee3cbf.svg";